<template>
  <div class="add-staff-dialog">
    <el-dialog
        :title="title"
        :visible="dialogStaffVisible"
        width="604px"
        :before-close="handleClose"
        @open="dialogOpen"
    >
      <div>
        <el-form :model="staffFormData" class="" ref="staffForm" :rules="staffFormRules" label-width="80px">
<!--          <div class="staff-head-portrait">-->
<!--            <svg-icon v-if="staffFormData.doctorGender === 2" class="head-portrait" icon-class="portraitGirl"/>-->
<!--            <svg-icon v-else class="head-portrait" icon-class="portraitMale"/>-->
<!--          </div>-->
          <div class="add-staff-dialog-staffAccount">
            <el-form-item label="账号" prop="account">
              <el-input
                  :disabled="currentStatus === 'look' || currentStatus === 'edit'"
                  v-model="staffFormData.account" autocomplete="off"
                  placeholder="请输入账号"
              ></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password" v-if="currentStatus !== 'edit'">
              <el-input
                  :disabled="currentStatus === 'look' || currentStatus === 'edit'"
                  type="password"  autocomplete="off"
                  v-model="staffFormData.password"
                  placeholder="请输入密码"
              ></el-input>
            </el-form-item>
          </div>
          <div class="add-staff-dialog-staffName">
            <el-form-item label="姓名" prop="doctorName">
              <el-input
                  :disabled="currentStatus === 'look'"
                  v-model="staffFormData.doctorName"
                  placeholder="请输入姓名"
                  @blur="doctorNameBlur"
              ></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group :disabled="currentStatus === 'look'" v-model="staffFormData.doctorGender">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <el-form-item label="角色" prop="roleIdList">
            <el-checkbox-group :disabled="currentStatus === 'look'" v-model="staffFormData.roleIdList">
              <el-checkbox v-for="(item, index) in roleList" :key="index" :label="item.id">{{
                  item.roleName
                }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <div class="flex-box">
            <el-form-item label="手机号码" prop="doctorPhone">
              <el-input
                  :disabled="currentStatus === 'look'"
                  v-model="staffFormData.doctorPhone"
                  placeholder="请输入手机号码"
              ></el-input>
            </el-form-item>
          </div>



<!--          <div class="add-staff-dialog-staffAccount">-->
<!--            <el-form-item label="职称" style="width:50%">-->
<!--              <el-select-->
<!--                  v-model="staffFormData.titleIdList"-->
<!--                  placeholder="选择职称"-->
<!--                  :disabled="currentStatus === 'look'"-->
<!--                  class="select"-->
<!--              >-->
<!--                <el-option-->
<!--                    v-for="selectOption in doctorTitleList"-->
<!--                    :key="selectOption.id"-->
<!--                    :label="selectOption.name"-->
<!--                    :value="selectOption.id"-->
<!--                ></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="科室" style="width:50%">-->
<!--              <el-select-->
<!--                  v-model="staffFormData.departmentIdList"-->
<!--                  placeholder="选择科室"-->
<!--                  class="select"-->
<!--                  multiple-->
<!--                  :disabled="currentStatus === 'look'"-->
<!--                  filterable-->
<!--              >-->
<!--                <el-option-->
<!--                    v-for="selectOption in departList"-->
<!--                    :key="selectOption.id"-->
<!--                    :label="selectOption.name"-->
<!--                    :value="selectOption.id"-->
<!--                ></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </div>-->

          <div class="add-staff-dialog-staffemail">
            <el-form-item label="电子邮箱" prop="email">
              <el-input
                  :disabled="currentStatus === 'look'"
                  v-model="staffFormData.email"
                  placeholder="请输入电子邮箱"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idCard">
              <el-input
                  :disabled="currentStatus === 'look'"
                  v-model="staffFormData.idCard"
                  placeholder="请输入身份证号码"
              ></el-input>
            </el-form-item>
          </div>


          <div class="flex-box">
            <el-form-item label="简介">
              <el-input
                  :disabled="currentStatus === 'look'"
                  type="textarea"
                  v-model="staffFormData.introduction"
                  placeholder="请输入员工简介"
                  class="staffProfile-input"
                  :maxlength="200"
                  :show-word-limit="true"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer-btn" v-if="currentStatus !== 'look'">
        <el-button @click="handleClose"
                   style=" background-color: rgb(46, 205, 129); border-color: rgb(46, 205, 129); color: white;"

        >返回</el-button>
        <el-button type="primary" @click="commitStaff" style=" background-color: rgb(46, 205, 129); border-color: rgb(46, 205, 129); color: white;"
        >提交账号信息</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
// import {findClinicDepartmentList, findDoctorTitleList} from "@/api/clinicmanagement/department/departmentApi.js"
// import Regular from "../../../../../util/regular/index";

export default {
  name: "AddStaff",
  props: {
    title: {
      type: String,
      default: ""
    },
    dialogStaffVisible: {
      type: Boolean,
      default: false
    },
    currentStatus: {
      type: String,
      default: ""
    },
    staffInfo: {
      type: Object,
      default: () => {
        return {
          doctorName: "",
          doctorGender: 1,
          roleIdList: [],
          doctorPhone: "",
          account: "",
          password: "",
          email: "",
          idCard: "",
          introduction: ""
        };
      }
    },
    roleList: {
      type: Array
      // default: []
    }
  },
  data() {
    return {
      doctorTitleList: [], // 职称列表
      departList: [], // 科室列表
      staffFormData: {},
      staffFormRules: {
        doctorName: [
          {required: true, message: "请输入姓名", trigger: "blur"},
          {validator: this.validateDoctorName, trigger: "blur"}
        ],
        roleIdList: [{required: true, message: "至少选择一个角色", trigger: "blur"}],
        account: [{required: true, message: "请输入账户", trigger: "blur"}],
        password: [{required: true, message: "请输入密码", trigger: "blur"}],
        doctorPhone: [{validator: this.validateDoctorPhone, trigger: "blur"}],
        email: [{validator: this.validateEmail, trigger: "blur"}],
        idCard: [{validator: this.validateIdCard, trigger: "blur"}]
      }
    };
  },
  methods: {
    // validateDoctorName(rule, value, callback) {
    //   if (Regular.moreName.test(value)) {
    //     return callback();
    //   } else {
    //     return callback(new Error("请输入正确姓名"));
    //   }
    // },
    // validateEmail(rule, value, callback) {
    //   if (Regular.email.test(value) || value === "") {
    //     return callback();
    //   } else {
    //     return callback(new Error("请输入正确电子邮箱"));
    //   }
    // },
    // validateIdCard(rule, value, callback) {
    //   if (Regular.IDCard.test(value) || value === "") {
    //     return callback();
    //   } else {
    //     return callback(new Error("请输入正确身份证号"));
    //   }
    // },
    // validateDoctorPhone(rule, value, callback) {
    //   if (Regular.notSeriousPhone.test(value) || value === "") {
    //     return callback();
    //   } else {
    //     return callback(new Error("请输入正确手机号码"));
    //   }
    // },
    handleClose() {
      this.$emit("update:dialogStaffVisible", false);
    },
    commitStaff() {
      this.$refs.staffForm.validate(valid => {
        if (valid) {
          if (this.staffFormData.titleIdList && this.staffFormData.titleIdList.length !== 0) {
            this.staffFormData.titleIdList = [this.staffFormData.titleIdList]
          } else {
            this.staffFormData.titleIdList = []
          }
          this.$emit("commitStaffInfo", _.cloneDeep(this.staffFormData));
        } else {
          return false;
        }
      });
    },
    doctorNameBlur() {

    },
    async findDoctorTitleList() {
      let params = {
        // doctorName:this.staffFormData.name
      }
      await this.$http.post(process.env.VUE_APP_API_HOST + "/api/get_doctor_title_list", params, {"content-type": "application/json"}).then(res => {
        if (res && res.code == "000000") {
          this.doctorTitleList = res.data.list
        }
      }).catch( )
    },
    async findClinicDepartmentList() {
      let params = {
        pageNum: 1,
        pageSize: 999
      }
      await this.$http.post(process.env.VUE_APP_API_HOST + "/api/get_clinic_dept_list", params, {"content-type": "application/json"}).then(res => {
        if (res && res.code == "000000") {

          this.departList = res.data.list
        }
      }).catch( )
    },
    /**
     * 弹窗打开时，初始化弹窗数据
     */
    dialogOpen() {
      this.findClinicDepartmentList();
      this.findDoctorTitleList();

      this.staffFormData = {
        doctorId: "",
        doctorName: "",
        doctorGender: 1,
        roleIdList: [],
        doctorPhone: "",
        account: "",
        password: "",
        email: "",
        idCard: "",
        introduction: "",
        departmentIdList: [],
        titleIdList: ""
      };
      if (this.staffInfo.doctorId) {
        for (let item in this.staffFormData) {
          if (this.staffInfo[item] && item != "titleIdList") {
            this.staffFormData[item] = this.staffInfo[item];
          }
        }
        if (this.staffInfo.roleNames.length > 0) {
          for (let roleName of this.staffInfo.roleNames) {
            this.staffFormData.roleIdList.push(this.roleList.find(role => role.roleName === roleName).id);
          }
        }
        /**
         * 职称是单选框，查询回来的是数据，需要转换
         */
        this.staffFormData.titleIdList = this.staffInfo.titleIdList[0];
      }

      this.$nextTick(() => {
        this.$refs.staffForm.clearValidate();
      });
    }
  },
  directives: {
    // removePlaceholder(el, binding) {
    //   // if (el.className.indexOf("is-disabled")) {
    //   //   el.setAttribute("placeholder", "")
    //   // }
    // }
  }
};
</script>

<style lang="less" scoped>
.add-staff-dialog {
  .add-staff-dialog-staffName,
  .add-staff-dialog-staffAccount,
  .add-staff-dialog-staffemail {
    display: flex;
    justify-content: flex-start;
  }

  .staff-head-portrait {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;

    svg {
      font-size: 86px;
    }
  }

  .staffProfile-input {
    width: 484px;
  }

  /deep/ .el-dialog__body {
    padding-bottom: 20px;
  }

  /deep/ .el-textarea__inner {
    resize: none;
  }
}
</style>
